<section class="tw-py-4"
         *ngIf="products?.length && !regimenRehaulV3Experiment"
         [ngClass]="{ 'justify-center': products?.length === 1, 'ordersBanner': banner || userOrder , 'userOrderBanner': userOrder, 'onlyOneProd': homePage && products?.length === 1, 'tw-bg-white': !ordersBanner, 'homeBanner': ordersBanner }">
  <h3 [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}"
      class="tw-px-5 tw-text-400 tw-text-gray-900 tw-mb-3"
      i18n="@@whatsInsideYourKit"
      *ngIf="!ordersBanner">
    What's inside your kit
  </h3>
  <ul class="tw-flex tw-flex-row tw-items-start tw-overflow-x-auto tw-mb-1 tw-pb-2 products-ul"
      [ngClass]="{ 'products-ul-max': products?.length > 4 }">
    <ng-container *ngFor="let product of products; let l = last; let i = index;">
      <li id="productImage"
          class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-gap-1"
          (click)="clickOnProductImage()">
        <div class="tw-w-20 tw-h-40 tw-flex tw-px-2"
             [ngClass]="{ 'height-new-ui': ordersBanner }">
          <img class="tw-object-contain tw-items-center tw-justify-center"
               [src]="getProductImage(product)" />
        </div>
        <p [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}"
           class="tw-font-bold tw-text-200 tw-text-gray-900 tw-text-center tw-mb-1 tw-leading-4"
           *ngIf="!(banner || userOrder)">
          {{product?.title || product?.hiddenTitle}}
        </p>
        <p class="tw-font-body tw-text-100 tw-text-gray-900 tw-text-center"
           *ngIf="!ordersBanner">
          {{product?.quantity}} {{product?.quantityUnit}}
        </p>
      </li>
      <li *ngIf="!l"
          class="tw-flex-none tw-pt-20"
          [ngClass]="{ 'padding-new-ui': ordersBanner }">
        <cs-icon class="tw-h-4 tw-w-4 tw-text-gray-900"
                 [iconName]="'add'"></cs-icon>
      </li>
    </ng-container>
  </ul>
  <div class="tw-px-5 tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-gap-1.5 tw-flex-row-reverse"
       *ngIf="!hideFooter && products?.length"
       [hidden]="hideButtons">
    @if (acqRebranding2025) {
    <button csButton="outlined"
            size="small"
            type="button"
            id="getInstructions"
            class="tw-flex-1 tw-m-0"
            (click)="seeInstructions()">
      <span i18n="@@getInstructions">Get Instructions</span>
      <cs-icon class="tw-h-4 tw-w-4 tw-text-green-400"
               [iconName]='"chevron_right"'></cs-icon>
    </button>
    <button csButton="outlined"
            size="small"
            type="button"
            id="readAboutProducts"
            class="tw-flex-1 tw-m-0"
            (click)="readMoreAboutProducts()">
      <span i18n="@@readMore">Read More</span>
      <cs-icon class="tw-h-4 tw-w-4 tw-text-green-400"
               [iconName]='"chevron_right"'></cs-icon>
    </button>
    } @else {
    <div id="getInstructions"
         class="tw-flex-auto tw-flex tw-items-center tw-justify-center tw-gap-3 tw-pl-4 tw-pr-3 tw-h-10 tw-border tw-border-gray-900 tw-font-body tw-font-bold tw-text-300 tw-text-green-500 tw-rounded-full"
         (click)="seeInstructions()">
      <span i18n="@@getInstructions">Get Instructions</span><cs-icon class="tw-h-4 tw-w-4 tw-text-green-400"
               [iconName]='"chevron_right"'></cs-icon>
    </div>
    <div id="readAboutProducts"
         class="tw-flex-auto tw-flex tw-items-center tw-justify-center tw-gap-3 tw-pl-4 tw-pr-3 tw-h-10 tw-border tw-border-gray-900 tw-font-body tw-font-bold tw-text-300 tw-text-green-500 tw-rounded-full"
         (click)="readMoreAboutProducts()">
      <span i18n="@@readMore">Read More</span><cs-icon class="tw-h-4 tw-w-4 tw-text-green-400"
               [iconName]='"chevron_right"'></cs-icon>
    </div>
    }
  </div>
</section>

<section *ngIf="regimenRehaulV3Experiment && products?.length"
         class="tw-py-4 tw-mb-2 tw-bg-gray-100">
  <h1 class="tw-font-body tw-text-400 tw-text-gray-800 tw-px-4 tw-mb-3"
      i18n="@@productsInsideYourKit">{{products?.length}} products inside your kit
  </h1>
  <swiper [config]="carouselConfig"
          class="tw-pl-4 tw-mb-4 tw-overflow-visible">
    @for (product of products; track $index) {
    <div *swiperSlide
         (click)="clickOnProductImage()"
         class="tw-h-full tw-relative tw-p-4 tw-flex tw-flex-col tw-gap-2.5 tw-bg-white tw-rounded-5 tw-overflow-hidden tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.10)]">
      <div
           class="tw-font-body tw-text-100 tw-text-gray-800 tw-pl-1.5 tw-pr-2.5 tw-py-1 tw-fixed tw-right-0 tw-top-0 tw-rounded-bl-2.5 tw-rounded-tr-5 tw-bg-gray-100">
        {{product?.quantity}}
        {{product?.quantityUnit}}</div>
      <div class="tw-flex-1 tw-flex tw-gap-4">
        <div class="tw-w-20 tw-h-40 tw-flex tw-px-2 tw-basis-1/4">
          <img class="tw-object-contain tw-items-center tw-justify-center"
               [src]="getProductImage(product)" />
        </div>
        <div class="tw-py-5 tw-basis-3/4">
          <h2 class="tw-font-lexend tw-font-bold tw-text-400 tw-text-gray-800 tw-mb-4">
            {{product?.title || product?.hiddenTitle}}
          </h2>
          @if (product?.productHighlights?.length) {
          <ul class="tw-list-disc tw-ml-4 tw-font-lexend tw-text-100 tw-text-gray-600">
            @for (highlight of product?.productHighlights; track $index) {
            <li [innerHTML]="highlight?.description"
                class="tw-mb-4 last:tw-mb-0"></li>
            }
          </ul>
          }
          @if (!product?.productHighlights?.length) {
          <p class="tw-font-lexend tw-font-normal tw-text-100 tw-text-gray-800 ">
            {{product?.description}}
          </p>
          }
        </div>
      </div>
      @if (product?.ingredients) {
      <div
           class="tw-h-8 tw-bg-gray-100 tw-p-2 tw-rounded-1.5 tw-font-body tw-italic tw-text-gray-500 tw-text-100 tw-truncate">
        <span i18n="@@keyIngridents">Key Ingredients</span>:&nbsp;{{typeof product?.ingredients === "string"?
        product?.ingredients : product?.ingredients?.keyActive}}
      </div>
      }
      @if (!product?.ingredients && product?.heroIngredients) {
      <div
           class="tw-h-8 tw-bg-gray-100 tw-p-2 tw-rounded-1.5 tw-font-body tw-italic tw-text-gray-500 tw-text-100 tw-truncate">
        <span i18n="@@keyIngridents">Key Ingredients</span>:&nbsp;
        @for (ing of product?.heroIngredients; track $index) {
        {{ing?.name}}
        }
      </div>
      }
      @if (!product?.ingredients && !product?.heroIngredients) {
      <div class="tw-h-8">&nbsp;</div>
      }
    </div>
    }
  </swiper>

  <div class="tw-px-5 tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-gap-3 tw-flex-row-reverse"
       *ngIf="!hideFooter && products?.length"
       [hidden]="hideButtons">
    <div id="getInstructions"
         class="tw-flex-auto tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-h-10 tw-font-body tw-font-bold tw-text-300 tw-text-teal-600"
         (click)="seeInstructions()">
      <span i18n="@@seeInstructions"
            class="tw-capitalize">See instructions</span><cs-icon class="tw-h-4 tw-w-4 tw-text-teal-600"
               [iconName]='"chevron_right"'></cs-icon>
    </div>
    <div id="readAboutProducts"
         class="tw-flex-auto tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-h-10 tw-font-body tw-font-bold tw-text-300 tw-text-white tw-rounded-3 tw-bg-teal-600 tw-shadow-z1"
         (click)="readMoreAboutProducts()">
      <span i18n="@@readMore">Read More</span><cs-icon class="tw-h-4 tw-w-4 tw-text-white"
               [iconName]='"chevron_right"'></cs-icon>
    </div>
  </div>
</section>
